<template>
  <div style="padding-top:30px">
      <div class="win" :style="'background-image:url('+oss+data.style.backgroundImage+')'">
    <!-- 背景比例 660 880  -->
    <div class="main" :style="'color:'+data.style.color">
      <div class="title" :style="'color:'+data.style.title_color">奖项已经被领走了!</div>
      <div class="s_flex_center m-b-5">
        <div class="first_title m-r-5"><img src="@/assets/images/user.png" alt="" style="width:24px;height:24px"> </div>
        <div class="time">领奖人：张三</div>
      </div>
      <span :style="'color:'+data.style.color">-领奖时间：2021-06-03 00-</span>
    </div>
    <div class="buttom" >
        <div class="button" >确认</div>
      </div>
  </div>
  </div>
</template>
<script>
import config from "@/config";
export default {
  name: "repeat",
  props: { data: Object },
  setup() {
    const oss = config.oss[process.env.VUE_APP_type];
    return {
      oss,
    };
  },
};
</script>

<style lang="less" scoped>
.win {
  width: 300px;
  height: 460px;
  margin: 0 auto;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: center;
  position: relative;
  .main {
    text-align: center;
    font-size: 13px;
    width: 100%;
    height: 100%;
    padding-top: 32px;
    .title {
      font-size: 15px;
      font-family: PingFang-SC-Heavy, PingFang-SC;
      font-weight: 800;
      margin-bottom: 30px;
    }
    .scanDetail {
      text-align: center;
      color: #fff;
      font-size: 15px;
      width: 80px;
      height: 28px;
      border-radius: 35px;
      background: #ef8537;
      line-height: 28px;
      margin: 0 auto;
    }
  }
  .buttom {
    width: 247.5px;
    height: 171px;
    background-size: contain;
    background-repeat: no-repeat;
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    padding-top: 90px;
    box-sizing: border-box;
    .button {
      width: 166.25px;
      height: 50px;
      background-color: #ff5555;
      color: #fff;
      border-radius: 50px;
      background-size: contain;
      background-repeat: no-repeat;
      font-size: 16px;
      background-position: center;
      margin: 0 auto;
      line-height: 45px;
      text-align: center;
      font-family: PingFang-SC-Bold, PingFang-SC;
      font-weight: bold;
    }
  }
}
</style>